<pbc-sorter [config]="KundenGruppesSorterConfig" [sorter]="kundenGruppes.sorter$ | async" (sorterChange)="kundenGruppes.sorter$.next($event)"></pbc-sorter>
